
let scrollValue_4 = 0;
let activeP4 = false;
let initFini_4 = false;
let titre_4 = document.getElementById("page4Titre");
let _scroll_4 = document.getElementById("page4Scroll");

window.addEventListener('wheel', onWheel);

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeP4) {  // Vérifie si la touche appuyée est 'Escape'
        //activeP2 = false
    }
});
  
let lastScrollTime_4 = 0; // Stocke le dernier timestamp d'exécution

function onWheel(event) {
    scrollValue_4 += event.deltaY/2;
    if (scrollValue_4 < 0) {
        scrollValue_4 = 0;
    }else if (scrollValue_4 > site1Image_4.clientHeight - site1ImageContainer_4.clientHeight) {
        scrollValue_4 = site1Image_4.clientHeight - site1ImageContainer_4.clientHeight;
    }

    

    site1Image_4.style.transform = `translateY(-${scrollValue_4}px)`;

    /*
    const now = Date.now(); // Récupère le temps actuel en millisecondes

    if (now - lastScrollTime_4 < 700) {
        return;
    }

    lastScrollTime_4 = now; // Met à jour le dernier temps d'exécution

    if (activeP4 && initFini_4) {
        const direction = Math.sign(event.deltaY); // -1 pour haut, 1 pour bas
        scrollValue_4 += direction;
        if (scrollValue_4 < 1) {
            scrollValue_4 = 4;
        }
        if (scrollValue_4 > 4) {
            scrollValue_4 = 1;
        }
        Scroll4(direction);

        window.animateJumpingLetters("page4Titre", 50, 200, 20, direction < 0);
        
    }*/
}

/*
const images = document.querySelectorAll('.sitestration_image');
let prevPosX = 0;
let PosX = 0;
let prevPosY = 0;
let PosY = 0;
images.forEach(image => {
    let isHovered = false;

    image.addEventListener('mouseenter', () => {
        isHovered = true;
        image.classList.add('hovered');
    });

    image.addEventListener('mouseleave', () => {
        isHovered = false;
        image.classList.remove('hovered');
    });

    image.addEventListener('mousemove', (e) => {
        if (isHovered) {

            const boundingBox = image.getBoundingClientRect();
            const offsetX = e.clientX - boundingBox.left;
            const offsetY = e.clientY - boundingBox.top;

            PosX = (((offsetX / boundingBox.width - 0.5) * 10) + prevPosX*29)/30;
            PosY = (((offsetY / boundingBox.height - 0.5) * 10) + prevPosY*29)/30;
            prevPosX = PosX; 
            prevPosY = PosY;

            image.style.transform = `translate(${PosX}px, ${PosY}px)`;

        }
    });
});*/


/* <div id="site1Container">
    <p id="site1Text"> voila le texte de l'site 1 </p>
    <div id="site1ImageContainer">
        <img id="site1" onclick="FullSite()" src="src/png/sitestrations/1.png" alt="sitestration 1"> 
    </div>
</div> */

function FullSite(){

}

function Scroll4(direction){
    let passe = scrollValue_4-direction;
    if (passe<1) {
        passe = 4;
      }
      if (passe>4) {
        passe = 1;
      }

    let prevSiteContainer = document.getElementById("site"+ passe +"Container");
    let prevSiteText = document.getElementById("site"+ passe +"Text");
    let prevSiteImageContainer = document.getElementById("site"+ passe +"ImageContainer");
    let prevSiteImage = document.getElementById("site"+ passe);
    let siteContainer = document.getElementById("site"+ scrollValue_4 +"Container");
    let siteText = document.getElementById("site"+ scrollValue_4 +"Text");
    let siteImageContainer = document.getElementById("site"+ scrollValue_4 +"ImageContainer");
    let siteImage = document.getElementById("site"+ scrollValue_4);
    prevSiteContainer.style.zIndex = 70;
    siteContainer.style.zIndex = 80;

    siteImage.style.pointerEvents = "all";
    prevSiteImage.style.pointerEvents = "none";
    
        console.log(passe + " vers " + scrollValue_4)
        let actualopacity = window.getComputedStyle(prevSiteContainer).opacity;
        const actualx = gsap.getProperty(prevSiteImageContainer, "x");
        console.log(actualx);
        gsap.to(prevSiteContainer, {
            opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });
        gsap.to(prevSiteImageContainer, {
            y: 200*direction,
            height: 0,
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });

        gsap.to(siteContainer, {
            opacity: 1,  // Valeur d'arrivée (l'élément disparaît)
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });
        gsap.fromTo(siteImageContainer, {
            y: -200*direction,
            height: 0},{
            y: 0 ,
            height: 400,
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });

    setTimeout(() => {
        
    }, 2000);  // Délai
    window.animateText("site"+ scrollValue +"Text",30,50,false,1,true)
}

let site1Container_4 = document.getElementById("site1Container");
let site1Text_4 = document.getElementById("site1Text");
let site1ImageContainer_4 = document.getElementById("site1ImageContainer");
let site1Image_4 = document.getElementById("site1");
function site1() {
    site1Image_4.style.transform = `translateY(-${0}px)`;
    setTimeout(() => {
        
        gsap.fromTo(site1Container_4, {
            opacity: 0,  // Valeur de départ (l'élément est visible)
        }, {
            opacity: 1,  // Valeur d'arrivée (l'élément disparaît)
            duration: 2,  // Durée de l'animation
            ease: "power4.Out"  // Courbe d'accélération
        });
        gsap.fromTo("#site1ImageContainer", 
            {
                height: "400px",
                x: "400px",  // Valeur de départ
                y: "0px"
            }, 
            {
                height: "400px",
                x: "0px",  // Valeur de fin
                y: "0px",
                duration: 2,
                ease: "power4.out",  // Courbe d'accélération
                overwrite: "auto"
            });
          
    }, 500);  // Délai
    setTimeout(() => {
        initFini_4 = true;
    }, 2500);  // Délai
    window.animateText("site1Text",30,1000,false,1,true)
}

let site1Container = document.getElementById("site1Container");
    site1Container.style.opacity = 0;
    site1Container.style.zIndex = 8;




titre_4.style.opacity = 0;
_scroll_4.style.opacity = 0;

///id, delay, offset, scint
function page4Start() {
    document.getElementById("page4").style.display = "flex";
    site1Container.style.opacity = 0;
    site1Container.style.zIndex = 8;
    gsap.set("#site1ImageContainer", {y: 400});
    site1Image_4.style.pointerEvents = "all";
    initFini_4 = false
    scrollValue_4 = 1;
    window.animateText("page4Titre",90,200,false)
    window.animateText("page4Scroll",90,2000,true)
    site1()
    setTimeout(() => {
        window.animateJumpingLetters("page4Titre",5,2,0);
    }, 2000);  // Délai
    activeP4 = true;
    gsap.to("#page4", {
        opacity: 1,  // Valeur d'arrivée (l'élément disparaît)
        duration: 1,  // Durée de l'animation
        ease: "power2.inOut"  // Courbe d'accélération
    });
    gsap.to("#page4Bg", {
        opacity: 0.5,  // Valeur d'arrivée (l'élément disparaît)
        duration: 2,  // Durée de l'animation
        ease: "power2.inOut"  // Courbe d'accélération
    });
}

function page4End() {
    document.getElementById("page4").style.display = "none";
    activeP4 = false;
    gsap.to("#page4", {
        opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
        duration: 1.5,  // Durée de l'animation
        ease: "power2.Out"  // Courbe d'accélération
    });

}

document.getElementById("page4").style.display = "none";
// Attacher la fonction à `window`
window.page4Start = page4Start;
window.page4End = page4End;